module.exports = "<div>\n    <div js-tree=\"config\"\n         ng-model=\"nodes\"\n         tree-events-obj=\"events\"\n         tree=\"instance\"\n    ></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/directoryTree/view.html
// module id = 926
// module chunks = 0